import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToolbarService {
  public drawerToggle = new EventEmitter();
  public search = new BehaviorSubject('');
  public tagIds$ = new BehaviorSubject<string[]>([]);
  public backClicked = new Subject();
  public backSubscription: Subscription;
  private toolbarDefinitionSubject = new BehaviorSubject<ToolbarDefinition>(new ToolbarDefinition('BillTech'));
  public toolbarDefinition = this.toolbarDefinitionSubject.asObservable();
  public resize$ = new Subject();

  constructor() {}

  public init(route: ActivatedRoute): void {
    route.data.subscribe((data) => {
        this.toolbarDefinitionSubject.next(
          new ToolbarDefinition(
            data.toolbar.title,
            data.toolbar.mainBtn,
            data.toolbar.prevPath,
            data.toolbar.tagFilter,
            data.toolbar.search,
            data.toolbar.searchPlaceholder,
            route,
            data.toolbar.progressPercentage
          ),
        );
      }
    );
  }

  public closeDrawer(): void {
    this.backClicked.next(true);
    this.drawerToggle.next(true);
  }

  public changeIconAfterClosing(): void {
    this.patch({
      mainBtn: 'menu',
    });

  }

  public openDrawer(): void {
    this.patch({
      mainBtn: 'close',
    });
    this.drawerToggle.emit();
  }

  public patch(toolbarDefinition: Partial<ToolbarDefinition>): void {
    this.toolbarDefinitionSubject.next({
      ...this.toolbarDefinitionSubject.value,
      ...toolbarDefinition,
    });
  }

  public onBackClicked(callback: () => any): void {
    if (this.backSubscription && !this.backSubscription.closed) {
      this.backSubscription.unsubscribe();
    }
    this.backSubscription = this.backClicked.subscribe(callback);
  }
}

export type mainBtnType = 'menu' | 'close' | 'back'

export class ToolbarDefinition {
  constructor(
    readonly title: string,
    readonly mainBtn: mainBtnType = 'menu',
    readonly prevPath: string = '',
    readonly tagFilter: boolean = false,
    readonly search: boolean = false,
    readonly searchPlaceholder: string = '',
    readonly route?: ActivatedRoute,
    readonly progressPercentage?: number,
  ) {}
}
